module.exports = "<h2>Olá,</h2>\n<p>Este é o Power-Up da Tinta no Pano</p>"